import React, { Component } from "react";
import { MdClose } from "react-icons/md";
import Modal from "react-modal";
import axios from "axios";
import config from "../../config";
import { Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Select from "react-select";
import utilityFunctions from "../../store/utilityFunctions";
import errorFunctions from "../../store/errorFunctions";
import StaffAdd from "./StaffAdd";
import StaffEdit from "./StaffEdit";
import "../common.css";
import LoadingPage from "../../components/Loading/Loading";
import { TablePagination } from "@material-ui/core";

export default class Staffs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddUser: false,
      showStaffAdd: false,
      showStaffEdit: false,
      showResetPwd: false,
      employeeID: "",
      typePassword: true,
      selectedUser: null,
      showConfirmDelete: false,
      showConfirmApprove: false,
      sellerOptions: [],
      locationOptions: [],
      selectedSeller: {},
      selectedLocation: {},
      storeLocationId: 0,
      data: [],
      filteredStaffs: [],
      searchFilter: "",
      loading: false,
      isLoading: false,
      storeValue: null,
      pageNumber: 1,
      rowPerPage: 10,
    };
  }

  handleDropDownAssignTo = (e) => {
    this.setState({ employeeID: e.target.value });
  };

  handleClickDelete = (item) => {
    this.setState({ selectedUser: item, showConfirmDelete: true });
  };

  handleClickApprove = (item) => {
    this.setState({
      selectedUser: item,
      showConfirmApprove: true,
      fullName: item?.name,
    });

    if (item?.store_location?.id) {
      this.setState({
        storeValue: [
          {
            label: item?.seller?.name + " - " + item?.store_location?.name,
            value: item?.store_location?.id,
          },
        ],
      });
    }
  };

  handleDelete = () => {
    this.setState({ loading: true });
    let url = `${config.backendServer}store_location/${this.state.selectedUser.store_location.id}/remove_staff/${this.state.selectedUser?.id}/`;
    const userInfo =
      localStorage.getItem("userInfo") ||
      utilityFunctions.getCookie("userInfo");
    // const isRedirect = userInfo && JSON.parse(userInfo)?.user.id === this.state.selectedUser?.id;
    const token = userInfo?.access_token || JSON.parse(userInfo)?.access_token;
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    fetch(url, options).then((response) => {
      this.setState({
        loading: false,
      });
      console.log(response.status);
      if (response.status === 204) {
        let tempUsers = this.state.data.filter(
          (x) => x.id !== this.state.data?.id
        );
        this.setState({
          showConfirmDelete: false,
          loading: false,
          data: tempUsers,
        });
        // if (isRedirect) window.location.href = "/sellers";
        if (this.props.userInfo.user.role.includes("Commercial"))
          this.retrieveStaffs(this.props.userInfo.user.store_location_id);
        else this.retrieveEmployees({ pageNumber: 1, rowPerPage: 10 });
        this.props.setDefaultTab();
      } else if (response.status === 406) {
        alert(`Delete is not allowed, User is already linked to ticket`);
      } else if (response.status === 409) {
        alert(`User does not exist.`);
      } else if (!this.state.selectedUser.store_location?.id) {
        alert(`store location does not exist.`);
      } else {
        alert("Problem with system. Please refresh and try again later.");
      }
    });
  };

  retrieveStoreLocation = () => {
    this.setState({
      isLoading: true,
    });
    this.props
      .protectedFetch(
        config.backendServer + "store_locations/",
        "GET",
        { country: config.country },
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.map((r) => {
          return { label: r.seller_name + " - " + r.name, value: r.id };
        });

        this.setState({
          sellers: res,
          filteredSellers: res,
          isLoading: false,
          locationOptions: [...[{ label: "--", value: "" }], ...options],
          selectedSeller: options.find((s) => s.value === res[0].id),
        });
      })
      .catch((err) => console.log(err));
  };

  retrieveEmployees = ({ urlTxt, rowPerPage, pageNumber, q } = {}) => {
    this.setState({ loading: true });

    const { isCin7, isApproval, protectedFetch } = this.props;
    const { rowPerPage: rowPage, pageNumber: statePage } = this.state;

    let baseUrl = config.backendServer + "employee/";

    if (urlTxt) {
      baseUrl = urlTxt;
    } else if (isCin7) {
      baseUrl += "?cin7_access=all,partial";
    } else if (isApproval) {
      baseUrl += "?status=requested";
    } else {
      baseUrl += "?roles=Commercial Staff,Commercial Admin&status=active";
    }

    if (!urlTxt) {
      baseUrl += `&limit=${rowPerPage || rowPage || 10}`;
      baseUrl += `&page=${pageNumber || statePage}`;
      baseUrl += `&pagination=true`;
    }

    if (q) {
      baseUrl += `&q=${q}`;
    }

    baseUrl += `&brand_id=${this.props.selectedbrandID}`;

    protectedFetch(baseUrl, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          loading: false,
          data: res?.results,
          filteredStaffs: res?.results,
          totalEmployee: res?.count,
          nextPageEmploy: res?.next,
          prevPageEmploy: res?.previous,
          rowPerPage: rowPerPage || 10,
          pageNumber: pageNumber ?? statePage ?? 1,
        });
      })
      .catch(() => {
        console.error("Failed to fetch employees");
        this.setState({ loading: false });
      });
  };

  handleChangePage = (event, newPage) => {
    let apiUrl = "";
    if (event.currentTarget.title === "Next page")
      apiUrl = this.state.nextPageEmploy;
    else apiUrl = this.state.prevPageEmploy;

    const pageNumber = newPage + 1;

    this.setState({
      pageNumber,
    });

    this.retrieveEmployees({
      urlTxt: apiUrl,
      pageNumber,
      rowPerPage: this.state.rowPerPage,
    });
  };

  handleChangeRowsPerPage = (event) => {
    const rowPerPage = parseInt(event.target.value, 10);
    this.setState({
      rowPerPage,
      pageNumber: 1,
    });
    this.retrieveEmployees({ rowPerPage: rowPerPage, pageNumber: 1 });
  };

  retrieveStaffs = (id) => {
    this.setState({ loading: true, storeLocationId: id });
    let url = "";

    if (this.state.page?.next) url = this.state.page.next;
    else if (this.state.page?.previous) url = this.state.page.next;
    else if (id)
      url = config.backendServer + `store_location/${id}/commercial_staff/`;

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          loading: false,
          data: res.results,
          filteredStaffs: res.results,
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    this.retrieveStoreLocation();
    if (
      this.props.userInfo.user.role.includes("Commercial") &&
      !this.props.isCin7 &&
      !this.props.isApproval
    )
      this.retrieveStaffs(this.props.userInfo.user.store_location_id);
    else
      this.retrieveEmployees({
        rowPerPage: 10,
        pageNumber: 1,
      });
  }

  handleAddUserCommercial = (userId, storeLocationId) => {
    this.setState({ loading: true });
    if (!userId && !this.state.storeLocationId) {
      alert("User is not selected");
      return;
    }
    let payload = {
      employee_id: userId,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post(
        `${config.backendServer}store_location/${
          this.state.storeLocationId || storeLocationId
        }/add_staff/`,
        payload,
        options
      )
      .then((res) => {
        let tempUsers = [...this.state.data];
        tempUsers.push(res.data);
        this.setState({
          loading: false,
          showAddUser: false,
          data: tempUsers,
          employeeID: "",
        });
        this.retrieveStaffs(this.props.serviceCenterId);
        this.props.setDefaultTab();
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
        //   resolve(err);
      });
    if (this.props.userInfo.user.role.includes("Commercial"))
      this.retrieveStaffs(this.props.userInfo.user.store_location_id);
    else this.retrieveEmployees();
  };

  handleResetPassword = () => {
    this.setState({ loading: true });
    if (!this.state.selectedUser) {
      alert("User is not selected");
      return;
    }
    let payload = {
      password: this.state.password1,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .put(
        `${config.backendServer}employee/${this.state.selectedUser.id}/change_password/`,
        payload,
        options
      )
      .then((res) => {
        console.log(res);
        alert("Password is changed");
        let tempUsers = [...this.state.data];
        tempUsers.push(res.data);
        this.setState({ loading: false, showResetPwd: false, data: tempUsers });
        this.retrieveStaffs(this.props.userInfo.user.store_location_id);
        this.props.setDefaultTab();

        // console.log("service user");
        // this.props.setCurrentTab;
        //   resolve(res);
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
        //   resolve(err);
      });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  onKeyDown = (e) => {
    if (e.key === "Enter")
      this.retrieveEmployees({ q: this.state.searchFilter });
  };

  handleRowClick = (item) => {
    if (!this.props.isCin7 && !this.props.isApproval) {
      if (["Admin", "Staff", "Commercial Admin"].includes(this.props.role))
        this.setState({ showStaffEdit: true, selectedUser: item });
    }
  };

  handleSelectSeller = (seller) => {
    const opt = this.state.sellers
      .find((sel) => sel.id === seller)
      ?.store_locations.map((s) => {
        return { value: s.id, label: s.name };
      });
    const locationOptions = [...[{ label: "All", value: "" }], ...opt];
    this.setState({ locationOptions });
  };

  handleSubmitApprove = () => {
    this.setState({ loading: true });

    const id = this.state.selectedUser?.id;
    let payload = {
      name: this.state.fullName,
      status: "active",
      store_location: this.state.storeValue?.value
        ? this.state.storeValue?.value
        : this.state.storeValue[0].value ?? "",
    };

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        this.setState({
          loading: false,
        });
        alert("Approve Success");
        this.retrieveEmployees({ rowPerPage: 10, pageNumber: 1 });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("fail");
        alert("Failed");
      });

    this.setState({ showConfirmApprove: false });
  };

  render() {
    // if (!this.state.loading && !this.state.data.length)
    //   return (
    //     <div>
    //       <span>No data available</span>
    //     </div>
    //   );
    const selectedUsersTemp = this.state.data?.map((x) => {
      return x.employee;
    });
    const optionEmployees = this.props.employees
      ?.filter((x) => !selectedUsersTemp?.includes(x.id))
      .map((val) => {
        return {
          value: parseInt(val.id),
          label: `${val.name} - ${val.user_role}`,
        };
      });
    const selectedAssignTo = optionEmployees?.find(
      (x) => x.value === this.state.employeeID
    );
    return (
      <div>
        <div className="row">
          <div className="d-flex justify-content-end gap-2 mb-3">
            <div className="input-group col-3 pr-0">
              <input
                type="text"
                placeholder="Search Customer"
                id={"searchFilter"}
                className={"form-control"}
                onChange={this.handleChange}
                onKeyDown={this.onKeyDown}
                value={this.state.searchFilter}
                // width={"100rem"}
              />
              <div className="input-group-prepend">
                <span className="form-control ">
                  <i className="fa fa-search form-control-icon"></i>
                </span>
              </div>
            </div>
            {!this.props.isCin7 && !this.props.isApproval ? (
              <button
                title="Add Customer"
                className="k-btn k-btn-primary k-btn-sm"
                onClick={() => {
                  this.setState({ showStaffAdd: true, selectedUser: null });
                }}
              >
                Add Commercial Staff
              </button>
            ) : null}
          </div>
          <div className="d-flex justify-content-end"></div>
        </div>

        {/* {["Admin", "Staff", "Commercial Admin"].includes(this.props.role) && (
          <div className="d-flex justify-content-end mb-2">
            <button type="button" className="btn btn-outline-primary btn-sm col-2 mr-2" onClick={() => this.setState({ showAddUser: true })}>
              Add existing user
            </button>
            <button
              type="button"
              className="btn btn-outline-primary btn-sm col-2"
              onClick={() => this.setState({ showStaffAdd: true, selectedUser: null })}
            >
              Create new user
            </button>
          </div>
        )} */}

        <TableContainer
          sx={{
            maxHeight: 600,
            overflowX: "hidden",
            border: "1px solid lightgray",
          }}
        >
          <Table
            aria-labelledby="tableTitle"
            size={"small"}
            aria-label="enhanced table"
          >
            <TableHead>
              <TableRow>
                <TableCell className="col-1 ">Name</TableCell>
                <TableCell className="col-3 ">Email</TableCell>
                <TableCell className="col-2 ">Role</TableCell>
                <TableCell className="col-1 ">Ticket Numbers</TableCell>
                {!this.props.isCin7 && !this.props.isApproval && (
                  <TableCell className="col-1 ">Store Location</TableCell>
                )}
                {this.props.isApproval && (
                  <TableCell className="col-1 ">Note</TableCell>
                )}
                {this.props.isCommercial && (
                  <TableCell className="col-1 ">Approved By</TableCell>
                )}
                <TableCell className="col-4"></TableCell>
              </TableRow>
            </TableHead>
            {this.state.loading && <LoadingPage />}
            <TableBody>
              {this.state.filteredStaffs &&
                this.state.filteredStaffs
                  .sort((a, b) => {
                    return b.id - a.id;
                  })
                  ?.map((item, i) => {
                    return (
                      <TableRow key={i} className="list-group-item">
                        <TableCell className="col-2 ">
                          <button
                            className="border-0 bg-white"
                            onClick={() => {
                              if (
                                !this.props.isCin7 &&
                                !this.props.isApproval
                              ) {
                                this.handleRowClick(item);
                              }
                            }}
                          >{`${item?.name}`}</button>
                        </TableCell>
                        <TableCell
                          className="col-2 cursor-"
                          onClick={() => {
                            if (!this.props.isCin7 && !this.props.isApproval) {
                              this.handleRowClick(item);
                            }
                          }}
                        >{`${item?.email}`}</TableCell>
                        <TableCell>{`${item?.user_role}`}</TableCell>
                        <TableCell className="col-1 ">
                          <Link
                            to={
                              "/tickets?store_location=" +
                              item.store_location.id
                            }
                          >
                            {item.ticket_count}
                          </Link>
                        </TableCell>
                        {!this.props.isCin7 && !this.props.isApproval && (
                          <TableCell className="col-1 ">{`${
                            item?.store_location?.name || ""
                          }`}</TableCell>
                        )}
                        {this.props.isApproval && (
                          <TableCell>
                            {item.commercial_location_notes || ""}
                          </TableCell>
                        )}
                        {this.props.isCommercial && (
                          <TableCell>
                            {`${item?.approver_role || ""} ${
                              item.approver_name
                                ? `- ${item.approver_name}`
                                : ""
                            }`}
                          </TableCell>
                        )}
                        <TableCell className="col-4">
                          {!this.props.isCin7 &&
                            !this.props.isApproval &&
                            ["Admin", "Staff", "Commercial Admin"].includes(
                              this.props.role
                            ) && (
                              <div className="row">
                                <button
                                  className="col btn btn-outline-info btn-sm mx-2"
                                  onClick={() => {
                                    this.setState({
                                      showResetPwd: true,
                                      selectedUser: item,
                                    });
                                  }}
                                >
                                  Reset Password
                                </button>

                                <button
                                  className={` col btn btn-sm  btn-outline-danger mx-2`}
                                  onClick={() => {
                                    this.handleClickDelete(item);
                                  }}
                                >
                                  Remove Store Location
                                </button>
                              </div>
                            )}
                          {this.props.isApproval &&
                            ["Admin", "Staff", "Commercial Admin"].includes(
                              this.props.role
                            ) && (
                              <div className="row mr-3">
                                <button
                                  className="col btn btn-outline-success btn-sm mx-2"
                                  onClick={() => {
                                    this.handleClickApprove(item);
                                  }}
                                >
                                  Approve
                                </button>
                              </div>
                            )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 100]}
          component="div"
          count={this.state.totalEmployee || 0}
          rowsPerPage={this.state.rowPerPage}
          page={this.state.pageNumber - 1}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
        />

        <Modal
          isOpen={this.state.showAddUser}
          //onRequestClose={()=>this.setState({showDeclineModal: false})}
          contentLabel={"Add Note"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showAddUser: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              {this.state.editedNote ? "Edit" : "Add"} Staff
            </div>
            <form>
              <div className={"card-body"}>
                <Select
                  data-testid="assign-to-select"
                  defaultValue={selectedAssignTo}
                  isSearchable={true}
                  options={optionEmployees}
                  // onInputChange={(val) => this.handleSearchServiceCenter(val)}
                  onChange={(obj) => {
                    this.setState({ employeeID: obj.value });
                    // this.handleSearchServiceCenter(obj);
                  }}
                />
              </div>
              <div className={"card-footer"}>
                <button
                  type="button"
                  className={"btn btn-outline-primary mr-3"}
                  onClick={() =>
                    this.handleAddUserCommercial(this.state.employeeID)
                  }
                >
                  Save
                </button>
                <button
                  type={"button"}
                  className={"btn btn-outline-secondary"}
                  onClick={() =>
                    this.setState({ showAddUser: false, addedNote: "" })
                  }
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showConfirmDelete}
          contentLabel={"Reset Password"}
          className={"input-modal-small"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showConfirmDelete: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              <h6>Remove Confirmation</h6>
            </div>
            <form>
              <div className="card-body text-center">
                <div className="mb-3">
                  Remove store location user {this.state.selectedUser?.name}?
                </div>
              </div>
              <div className="card-footer">
                <div className="row ">
                  <div className="col-6 text-right ">
                    <button
                      type="button"
                      className={"btn btn-outline-danger"}
                      onClick={() => {
                        this.handleDelete();
                        // if (this.state.modalCaption.toLowerCase().includes("reset")) this.handleResetPassword();
                        // else this.handleSendVerification(event);
                        // this.setState({ showModalResetPassword: false });
                      }}
                    >
                      Remove
                    </button>
                  </div>
                  <div className="col-6 text-left">
                    <button
                      type={"button"}
                      className={"btn btn-outline-secondary"}
                      onClick={() =>
                        this.setState({ showConfirmDelete: false })
                      }
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showStaffAdd}
          contentLabel={"Add Staff"}
          className={"input-modal"}
        >
          <StaffAdd
            user={this.state.selectedUser}
            protectedFetch={this.props.protectedFetch}
            closeModal={() => this.setState({ showStaffAdd: false })}
            addExistingUser={(userId, storeLocationId) =>
              this.handleAddUserCommercial(userId, storeLocationId)
            }
            retrieveStaffs={() =>
              this.props.userInfo.user?.store_location_id
                ? this.retrieveStaffs(
                    this.props.userInfo.user.store_location_id
                  )
                : this.retrieveEmployees()
            }
          />
        </Modal>
        <Modal
          isOpen={this.state.showStaffEdit}
          contentLabel={"Edit Staff"}
          className={"input-modal"}
        >
          <StaffEdit
            user={this.state.selectedUser}
            protectedFetch={this.props.protectedFetch}
            closeModal={() => this.setState({ showStaffEdit: false })}
            retrieveStaffs={() =>
              this.props.userInfo.user?.store_location_id
                ? this.retrieveStaffs(
                    this.props.userInfo.user.store_location_id
                  )
                : this.retrieveEmployees()
            }
            // addExistingUser={(id) => this.handleAddUserCommercial(id)}
          />
        </Modal>
        <Modal
          isOpen={this.state.showResetPwd}
          contentLabel={"Reset Password"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showResetPwd: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              <h6>Reset Password Confirmation</h6>
            </div>
            <form>
              <div className="card-body text-start">
                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Password{" "}
                    <i
                      className={
                        this.state.typePassword
                          ? "password-show fa fa-eye"
                          : "password-show fa fa-eye-slash"
                      }
                      aria-hidden="true"
                      onClick={() =>
                        this.setState({
                          typePassword: !this.state.typePassword,
                        })
                      }
                    ></i>
                    <span>:</span>
                  </label>
                  <input
                    type={this.state.typePassword ? "password" : "text"}
                    id="password1"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                  />
                  {this.state.errorPassword ? (
                    <span className="error-text">Password did not match</span>
                  ) : null}
                </div>
                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Confirm Password <span>:</span>
                  </label>
                  <input
                    type={this.state.typePassword ? "password" : "text"}
                    id="password2"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                  />
                  {this.state.errorPassword ? (
                    <span className="error-text">Password did not match</span>
                  ) : null}
                </div>
              </div>
              <div className="card-footer">
                <div className="row ">
                  <div className="col-6 text-right ">
                    <button
                      type="button"
                      className={"btn btn-outline-info"}
                      disabled={
                        this.state.password1 !== this.state.password2 ||
                        !this.state.password1
                      }
                      onClick={() => {
                        this.handleResetPassword();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                  <div className="col-6 text-left">
                    <button
                      type={"button"}
                      className={"btn btn-outline-secondary"}
                      onClick={() => this.setState({ showResetPwd: false })}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.showConfirmApprove}
          contentLabel={"Approve Account"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showConfirmApprove: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              <h6>Approve Confirmation</h6>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className={"card"} style={{ height: "100%" }}>
                <div className="card-body">
                  <div className={"single-warranty-details-item"}>
                    <label className={"single-warranty-details-label"}>
                      Email: {this.state?.selectedUser?.email || ""}
                    </label>
                  </div>
                  <div className={"single-warranty-details-item"}>
                    <label className={"single-warranty-details-label"}>
                      Full name:
                    </label>
                    <input
                      type="text"
                      id="name"
                      required={true}
                      defaultValue={
                        this.state.selectedUser?.name || this.state.fullName
                      }
                      className="form-control"
                      onChange={(e) => {
                        this.setState({ fullName: e.target.value });
                      }}
                    />
                  </div>
                  <div key={3} className="form-input">
                    <label>{"Store Location"}</label>
                    <Select
                      id={"storeLocation"}
                      data-testid="assign-to-select"
                      value={this.state.storeValue}
                      isSearchable={true}
                      options={this.state.locationOptions}
                      isLoading={this.state.isLoading}
                      onChange={(obj) => {
                        this.setState({ storeValue: obj });
                      }}
                    />
                  </div>
                  <div className={"single-warranty-details-item"}>
                    <label className={"single-warranty-details-label"}>
                      Note:{" "}
                      {this.state?.selectedUser?.commercial_location_notes ||
                        ""}
                    </label>
                  </div>
                </div>
              </div>

              <div className="card-footer">
                <div className="row ">
                  <div className="col-3 text-right ">
                    <button
                      type="button"
                      className={"btn btn-outline-primary"}
                      disabled={
                        this.state.fullName === "" ||
                        this.state.storeValue === null
                      }
                      onClick={() => {
                        if (
                          this.state.fullName !== "" ||
                          this.state.storeValue !== null
                        ) {
                          this.handleSubmitApprove();
                        }
                      }}
                    >
                      Approve
                    </button>
                  </div>
                  <div className="col-3 text-left">
                    <button
                      type={"button"}
                      className={"btn btn-outline-secondary"}
                      onClick={() =>
                        this.setState({ showConfirmApprove: false })
                      }
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    );
  }
}
